<template>
	<div class="author-upload">
		<vs-alert color="warning" class="mb-2 p-2" v-html="$t('authorHint')"/>
		<vs-upload
			:key="'filesToUpload' + filesToUploadCounter"
			:show-upload-button="false"
			:text="$t('loadFile')"
			:disabled="isUploadDisabled"
			accept=".jpg,.jpeg,.png,.xls,.xlsx,.docx,.doc,.odt,.rtf,.pdf,.txt,.csv,.zip,.pages,.sav,.MP4,.MOV,.MPG,.AVI,.M4V,.3GP,.3GGP,.MX20,.MX18,.MX12,.r,.ppt,.pptx"
			@change="addPhoto"
			@on-delete="deletePhoto"
		/>

		<div
			v-if="filesToUpload.length !== 0"
			:class="{ 'disabled-confirm-button': isConfirmDisabled }"
			class="mt-5"
		>
				<span
					class="status status-ok cursor-pointer mt-3"
					@click="uploadPhotos"
				>
					{{ $t("confirmUploading") }}
				</span>
		</div>

		<div v-if="files.length !== 0" class="mt-5 mb-3">
			<b>{{ $tc("attachedFiles", files.length) }}:</b>
		</div>

		<div class="vx-row">
			<div
				v-for="(file, index) in files"
				:key="index"
				class="vx-col flex column mt-5 uploaded-file"
			>
				<FileNameView
					class="mb-3"
					:url="file.url"
					:orderId="orderId"
					@fileDeleted="updateModel"
					:createdAt="file.created_at"
				/>
				<FileNameView
					v-if="
						file.report_file_plag_scan &&
							file.report_file_plag_scan !== null
					"
					class="mb-3"
					:isReportFile="true"
					:url="file.report_file_plag_scan"
					:orderId="orderId"
				/>
				<div
					v-if="
							file.percent_plagiat >= 0 &&
								file.percent_plagiat !== null
						"
					class="mb-3"
				>
					{{ $t("plagiatPercentage") }} -
					{{ file.percent_plagiat + " %" }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FileNameView from "@/views/Tickets/FileNameView";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: 'UploadAuthorsWork',
	mixins: [databaseManager, notifier],
	props: {
		orderId: { required: true, type: Number },
		orderStatus: { required: true, type: String },
		stage: { required: true, type: Object, default: () => ({}) },
	},
	components: {
		FileNameView
	},
	data() {
		return {
			filesToUpload: [],
			filesToUploadCounter: 0,
			isConfirmDisabled: false
		};
	},
	computed: {
		files() {
			if (!this.stage || !this.stage.files) return [];
			return this.stage.files;
		},
		isUploadDisabled() {
			return (
				this.orderStatus !== "waiting_approve" &&
				this.orderStatus !== "in_progress"
			);
		}
	},
	methods: {
		async updateModel(callback) {
			await this.$emit("update-model", callback);
		},
		addPhoto(path, files) {
			this.filesToUpload.push(files[files.length - 1]);
		},
		deletePhoto(file) {
			const index = this.filesToUpload.findIndex(item => item === file);
			if (index !== -1) {
				this.filesToUpload.splice(index, 1);
			}
		},
		refreshInput() {
			this.filesToUpload = [];
			this.filesToUploadCounter++;
		},
		async uploadCallback() {
			try {
				if (this.isUploadDisabled) {
					this.refreshInput();
					this.notifyError(this.$t("isConfirmingStage"));
					return;
				}
				// if (!(this.stage && this.$store.state.auth.role === "author"))
				// 	return;

				const urls = await this.dbUploadMany(this.filesToUpload);

				const successfulUploads = urls.length;
				const totalFiles = this.filesToUpload.length;

				if (successfulUploads < totalFiles) {
					this.notifyError(
						this.$t('uploadWarning', { success: successfulUploads, total: totalFiles })
					);
				}

				const files = urls.map(item => item.url);

				const attachUrl = `/${this.$store.state.auth.role}/order/attach-files/${this.$route.params.id}`;
				const attachOptions = `?milestone_id=${this.stage.id}`;
				const request = `${attachUrl}${attachOptions}`;
				const res = (await this.$http.post(request, { files })).data
					.data;

				res.files.forEach(item => this.files.push(item));

				this.refreshInput();

				if (this.$store.state.auth.role === 'author') {
					this.notifySuccess(
						`${this.$t("thanksWeReceivedYourRequest")}.<br>` +
						`${this.$t("managerWillConfirmItSoon")}. ` +
						`${this.$t("pleaseWait")}`
					);
				}
			} catch (e) {
				this.notifyError(e.message);
			} finally {
				setTimeout(() => {
					this.isConfirmDisabled = false;
				}, 500);
			}
		},
		async uploadPhotos() {
			if (this.isConfirmDisabled) return;

			this.isConfirmDisabled = true;
			await this.uploadCallback()
			this.$emit("update-model");
		}
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.author-upload {
	.uploaded-file {
		min-width: 0;
	}

	.con-img-upload {
		//overflow: auto !important;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}

	.disabled-confirm-button {
		.status {
			background-color: #d5d5d5;
			cursor: not-allowed !important;
		}
	}

	.con-img-upload {
		margin: -10px;
		overflow: initial;

		.con-input-upload,
		.img-upload {
			margin: 10px;
		}
	}

	.img-upload {
		&.removeItem {
			display: none;
		}
	}

	.status {
		font-size: rem(14px);
		background-color: $primary;
		color: white;
		padding: 5px 10px;
		border-radius: 10px;
		flex-shrink: 0;

		&-ok {
			background-color: $success;
		}
	}
}
</style>
